import {FormattedMessage} from 'react-intl';
import {
    FetchError,
    Loading,
    ProfileInformation,
} from '../../../components';
import {useQuery} from '../../../hooks';
import {
    Endpoint,
    extractErrorMessage,
} from '../../../util';

export function Profile() {
    const {
        data: currentUserProfile,
        error,
        isError,
        isPending,
    } = useQuery({endpoint: Endpoint.PROFILE});

    return (
        <section className={'account-content account-and-security'}>
            <header>
                <img
                    alt={''}
                    className={'icon'}
                    role={'presentation'}
                    src={'/images/icon-profile.svg'}
                />
                <h2 data-test-id={'account-profile-title'}>
                    <FormattedMessage id={'account.profile.title'} />
                </h2>
            </header>
            {isError
                ? <FetchError reason={extractErrorMessage(error)} />
                : isPending
                ? (
                    <div className={'center-within'}>
                        <Loading />
                    </div>
                )
                : <ProfileInformation {...currentUserProfile} />}
        </section>
    );
}
